import { useCustomerTokens } from '@hooks/customer/useCustomerTokens';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import axios, { AxiosRequestConfig } from 'axios';
import { setCustomerToken } from '@utils/userTokens';
import { signedIn } from '@repo/ui/src/services/analytics';
import { identify } from '@repo/ui/src/utils/identify';
import useSWRMutation from 'swr/mutation';
import { initialValues } from '@repo/ui/src/modules/UI/constants';

const { auth } = publicRuntimeConfig;

interface Key extends AxiosRequestConfig {
  mutate: ReturnType<typeof useCustomerTokens>['mutate'];
}
const fetcher = async (
  { mutate, ...key }: Key,
  { arg: input }: { arg: typeof initialValues.logIn },
) => {
  const { data: session } = await axios({
    ...key,
    data: { username: input.username, password: input.password },
  });

  if (session.idToken) {
    signedIn({ email: input.username, first_name: '', last_name: '' });
    setCustomerToken(session, input.rememberMe);
    await mutate();
  }

  identify({ email: input.username });
};

export const useLogin = () => {
  const { mutate } = useCustomerTokens();

  return useSWRMutation(
    {
      url: `${auth?.url ?? ''}/tokens`,
      method: 'POST',
      mutate,
    },
    fetcher,
  );
};
